export default "__VITE_ASSET__DUikEGoH__"